// Google Analytics 4 — caricato SOLO dopo il consenso dell'utente (cookie banner)
// e SOLO sul dominio di produzione, per non sporcare i dati con staging/localhost.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-3SMJ602SRT';
const PROD_HOST = 'festedapiccoli.it';

let caricato = false;

// True se l'utente ha dato il consenso ai cookie di analisi.
export function gaConsentito() {
  return localStorage.getItem('cookie_consent') === 'all';
}

// Carica gtag.js e inizializza GA. Idempotente: non ricarica se già fatto.
export function caricaGA() {
  if (caricato || !GA_ID) return;
  if (typeof window === 'undefined') return;
  // Niente tracciamento fuori dalla produzione (staging onrender.com / localhost).
  if (window.location.hostname !== PROD_HOST) return;
  if (!gaConsentito()) return;

  caricato = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // anonymize_ip per ridurre i dati personali raccolti.
  window.gtag('config', GA_ID, { anonymize_ip: true });
}

// Registra una pagina vista (per la SPA, sui cambi di route).
export function gaPageView(path) {
  if (!caricato || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}
